"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, core_1.createStyles)({
        tooltipWrapper: function (_a) {
            var width = _a.width;
            return ({
                width: width !== null && width !== void 0 ? width : 'auto',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
            });
        },
        layoutRoot: {
            display: 'contents',
            width: '100%',
        },
        root: function (_a) {
            var component = _a.component;
            return (__assign(__assign({}, theme_1.default.fonts.button), { borderRadius: 4, display: component === 'button' ? 'inline-block' : 'inline-flex', whiteSpace: 'nowrap', textTransform: 'none', minWidth: 'unset', '& > *': {
                    display: 'flex',
                } }));
        },
        icon: {
            width: 24,
            height: 24,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 12,
            '$textVariant &, $textDarkVariant &': {
                marginRight: 4,
            },
        },
        expandIcon: {
            width: 24,
            height: 24,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 12,
            transition: theme_1.default.transitions.easeOutFast,
            '$textVariant &, $textDarkVariant &': {
                marginLeft: 4,
            },
        },
        expandIconExpanded: {
            transform: 'rotate(180deg)',
        },
        primaryVariant: function (_a) {
            var withIcon = _a.withIcon, isExpandable = _a.isExpandable, isLoading = _a.isLoading;
            return ({
                minHeight: 32,
                padding: "0px ".concat(isExpandable ? 10 : 20, "px 0px ").concat(withIcon ? 10 : 20, "px"),
                backgroundColor: theme_1.default.colors.primary,
                border: '2px solid transparent',
                '&:hover': {
                    backgroundColor: theme_1.default.colors.primaryDark,
                },
                '&:disabled': {
                    backgroundColor: isLoading ? theme_1.default.colors.primary : (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primary, 0.5),
                },
                '&:focus-visible': {
                    backgroundColor: theme_1.default.colors.primaryDark,
                    borderColor: theme_1.default.colors.primaryLight,
                },
            });
        },
        secondaryVariant: function (_a) {
            var withIcon = _a.withIcon, isExpandable = _a.isExpandable, isLoading = _a.isLoading;
            return ({
                minHeight: 32,
                padding: "0px ".concat(isExpandable ? 11 : 21, "px 0px ").concat(withIcon ? 11 : 21, "px"),
                backgroundColor: 'transparent',
                border: "1px solid ".concat(theme_1.default.colors.primary),
                transitionProperty: 'background, box-shadow',
                '&:hover': {
                    backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5)),
                },
                '&:disabled': {
                    border: isLoading ? "1px solid ".concat(theme_1.default.colors.primary) : "1px solid ".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primary, 0.5)),
                },
                '&:focus-visible': {
                    borderWidth: '2px',
                    borderColor: theme_1.default.colors.primary,
                    backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5)),
                    padding: "0px ".concat(isExpandable ? 10 : 20, "px 0px ").concat(withIcon ? 10 : 20, "px"),
                },
            });
        },
        alertVariant: function (_a) {
            var withIcon = _a.withIcon, isExpandable = _a.isExpandable, isLoading = _a.isLoading;
            return ({
                minHeight: 32,
                padding: "0px ".concat(isExpandable ? 10 : 20, "px 0px ").concat(withIcon ? 10 : 20, "px"),
                backgroundColor: theme_1.default.colors.error,
                border: '2px solid transparent',
                '&:hover': {
                    backgroundColor: theme_1.default.colors.errorDark,
                },
                '&:disabled': {
                    backgroundColor: isLoading ? theme_1.default.colors.error : (0, styleUtilities_1.withOpacity)(theme_1.default.colors.error, 0.5),
                },
                '&:focus-visible': {
                    backgroundColor: theme_1.default.colors.errorDark,
                    borderColor: theme_1.default.colors.errorLight,
                },
            });
        },
        textVariant: {
            padding: 0,
            backgroundColor: 'transparent !important',
            '&:hover *': {
                color: "".concat(theme_1.default.colors.primaryDark, " !important"),
                fill: "".concat(theme_1.default.colors.primaryDark, " !important"),
            },
            '&:focus-visible *': {
                color: "".concat(theme_1.default.colors.primaryDark, " !important"),
                fill: "".concat(theme_1.default.colors.primaryDark, " !important"),
            },
            '&:focus-visible span span': {
                position: 'relative',
                '&:after': {
                    content: '""',
                    height: 2,
                    borderRadius: 3,
                    backgroundColor: theme_1.default.colors.primaryDark,
                    width: '100%',
                    position: 'absolute',
                    bottom: -2,
                    left: 0,
                },
            },
        },
        textDarkVariant: {
            padding: 0,
            '&:hover, &:focus': {
                backgroundColor: 'transparent',
            },
            '&:focus-visible span span': {
                position: 'relative',
                '&:after': {
                    content: '""',
                    height: 2,
                    borderRadius: 3,
                    backgroundColor: theme_1.default.colors.dark,
                    width: '100%',
                    position: 'absolute',
                    bottom: -2,
                    left: 0,
                },
            },
        },
        darkColor: {
            '&:hover *': {
                color: 'inherit !important',
            },
        },
        fullWidth: {
            width: '100%',
        },
        disabled: {
            cursor: 'not-allowed',
        },
    });
});
